"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_select_1 = require("react-select");
const react_select_2 = __importDefault(require("react-select"));
exports.FilterComponent = ({ onChange, options, onInputChange: handleInputChange, }) => {
    const [selfOptions, setSelfOptions] = react_1.useState(options);
    const onFilterChange = (option) => {
        option ? onChange(option.value) : onChange("");
    };
    react_1.useEffect(() => {
        setSelfOptions(options);
    }, [options]);
    const customStyles = {
        menu: (styles) => ({ ...styles, width: "auto" }),
        options: (styles) => ({ ...styles, fontWeight: "200" }),
    };
    const onInputChange = (newValue, actionMeta) => {
        const newOptions = foundInOption(options, newValue);
        setSelfOptions(newOptions);
        handleInputChange && handleInputChange(newValue, actionMeta);
    };
    return (react_1.default.createElement(react_select_2.default, { filterOption: react_select_1.createFilter({ ignoreCase: true }), styles: customStyles, isClearable: true, onChange: onFilterChange, onInputChange: onInputChange, options: selfOptions.slice(0, 200) }));
};
const foundInOption = (options, text) => {
    let exp = new RegExp(text, "ig");
    return options.filter((option) => exp.test(option.value));
};
//# sourceMappingURL=FilterComponent.js.map